<template>
  <v-container>
    <v-card class="transparent" elevation="0">
      <v-card-title class="justify-space-between">
        <span class="secondary--text font-weight-bold headline">
          {{ dikr.TITLE }}
        </span>
        <v-btn
          fab
          small
          color="error"
          @click="
            toggleFav();
            favSnackbar = true;
          "
        >
          <v-icon>{{ isFav ? "fas" : "far" }} fa-heart</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <vuetify-audio-player
          :src="dikr.AUDIO_URL"
          :track-title="dikr.TITLE"
          :compact="$vuetify.breakpoint.smAndDown"
          prev-track-icon="fa-step-forward"
          next-track-icon="fa-step-backward"
          back-forward-icon="fa-fast-forward"
          fast-forward-icon="fa-fast-backward"
          play-icon="fa-play"
          pause-icon="fa-pause"
          mute-volume-icon="fa-volume-mute"
          low-volume-icon="fa-volume-off"
          medium-volume-icon="fa-volume-down"
          high-volume-icon="fa-volume-up"
        ></vuetify-audio-player>
      </v-card-text>
    </v-card>

    <!-- sub dikr -->
    <v-card max-width="400" class="mx-auto elevation-5 my-2">
      <v-card-text>
        <v-carousel
          :height="hasMulti ? 300 : 'auto'"
          hide-delimiters
          :show-arrows="false"
          v-model="activeSubDikr"
        >
          <!-- carousel items -->
          <v-carousel-item v-for="c in dikr.children" :key="c._id">
            <dikr-child :sub-dikr="c"></dikr-child>
          </v-carousel-item>
        </v-carousel>
      </v-card-text>
      <v-card-actions v-if="hasMulti">
        <!-- custom carousel arrows -->
        <v-btn rounded color="primary" dark class="my-3" @click="nextSubDikr()">
          <v-icon small>fa-angle-right</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <span class="headline">
          {{ $t("doa2") + " " + (activeSubDikr + 1) }}
        </span>
        <v-spacer></v-spacer>
        <v-btn rounded color="primary" dark class="my-3" @click="prevSubDikr()">
          <v-icon small>fa-angle-left</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>

    <!-- copy_text toast -->
    <v-snackbar v-model="textCopiedSnackbar" :timeout="3000" top multi-line>
      {{ $t("text_copied") }}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="primary"
          icon
          v-bind="attrs"
          @click="textCopiedSnackbar = false"
        >
          <v-icon>fa-times</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <!-- add to favourite toast -->
    <v-snackbar v-model="favSnackbar" :timeout="1000" top multi-line>
      {{ isFav ? $t("added_to_favourite") : $t("remove_from_favourite") }}
      <template v-slot:action="{ attrs }">
        <v-btn color="primary" icon v-bind="attrs" @click="favSnackbar = false">
          <v-icon>fa-times</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <!-- share modal -->
    <v-dialog
      v-model="shareDialog"
      transition="dialog-top-transition"
      max-width="600px"
      persistent
      :fullscreen="xs"
    >
      <v-card>
        <v-card-title>
          <v-icon color="primary">fa-mosque</v-icon>
          <v-spacer></v-spacer>
          <v-icon @click="shareDialog = false" color="primary">fa-times</v-icon>
        </v-card-title>
        <v-card-title
          class="headline my-3 text-center justify-center"
          color="primary"
        >
          {{ dikr.TITLE }}
        </v-card-title>
        <v-card-text class="my-4 text-center">
          {{ currentSubDikr.ARABIC_TEXT }}
        </v-card-text>
        <v-card-actions>
          <v-col cols="12">
            <div>شارك عبر</div>
            <v-text-field
              readonly
              :value="setDikrURL(currentSubDikr.ID)"
              class="full-width my-4"
              dir="ltr"
              outlined
              filled
            ></v-text-field>
            <v-row class="justify-center justify-space-around my-4">
              <v-tooltip v-for="btn in shareBtns" :key="btn.icon" top>
                <template v-slot:activator="{ on, attrs }">
                  <template v-if="['link'].includes(btn.network)">
                    <v-btn
                      fab
                      class="mx-1 my-2"
                      :color="btn.color"
                      medium
                      elevation="2"
                      dark
                      v-bind="attrs"
                      v-on="on"
                      @click="copyToClipboard(setDikrURL(currentSubDikr.ID))"
                    >
                      <v-icon medium>{{ btn.icon }}</v-icon>
                    </v-btn>
                  </template>
                  <template v-else>
                    <share-network
                      class="mx-1 my-2"
                      :network="btn.network"
                      :url="setDikrURL(currentSubDikr.ID)"
                      :title="dikr.TITLE"
                      :description="currentSubDikr.ARABIC_TEXT"
                      :hashtags="dikr.TITLE.replace(/ /g, ',')"
                      fab
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-btn fab :color="btn.color" medium elevation="2" dark>
                        <v-icon medium>{{ btn.icon }}</v-icon>
                      </v-btn>
                    </share-network>
                  </template>
                </template>
                <span>{{ btn.tooltip }}</span>
              </v-tooltip>
            </v-row>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <audio
      v-show="false"
      :src="currentSubDikr.AUDIO_URL"
      controls
      ref="sub-audio-player"
      @ended="endedHandler()"
    ></audio>
  </v-container>
</template>

<script>
import VuetifyAudioPlayer from "@/components/VuetifyAudioPlayer.vue";
import DikrChild from "../components/DikrChild.vue";

export default {
  name: "dikr",
  components: {
    VuetifyAudioPlayer,
    DikrChild,
  },
  computed: {
    xs() {
      return this.$vuetify.breakpoint.name === "xs";
    },
    shareBtns() {
      return [
        {
          color: "#128c7e",
          tooltip: this.$t("whatsapp"),
          network: "whatsapp",
          icon: "fab fa-whatsapp",
        },
        // {
        //   color: "#3b5998",
        //   tooltip: "facebook",
        //   icon: "fab fa-facebook",
        // },
        {
          color: "#00B2FF",
          tooltip: this.$t("messenger"),
          network: "messenger",
          icon: "fab fa-facebook-messenger",
        },
        {
          color: "#1da1f2",
          tooltip: this.$t("twitter"),
          network: "twitter",
          icon: "fab fa-twitter",
        },
        {
          color: "primary",
          tooltip: this.$t("link"),
          network: "link",
          icon: "fa fa-link",
        },
      ];
    },
  },
  data: () => ({
    activeSubDikr: 0,
    isFav: false,
    slug: "",
    dikr: {},
    hasMulti: false,
    // sub/children
    currentSubDikr: {},
    // copy
    textCopiedSnackbar: false,
    // share
    shareDialog: false,
    // favourite
    favSnackbar: false,
  }),
  created() {
    this.slug = this.lowerCase(this.$route.params.slug);
    this.$store.dispatch("findOneBySlug", this.slug).then((res) => {
      res.children.forEach((element) => {
        element.actions = [
          {
            active: false,
            icons: ["fa-pause", "fa-play"],
            tooltip: this.$t("play_pause"),
            network: "play_pause",
            render: res.children.length > 1,
            cb: (sub) => {
              const { ID } = sub;
              const $thisObj = this.dikr.children.find((d) => d.ID === ID)
                .actions[0];

              this.currentSubDikr = sub;

              $thisObj.active = !$thisObj.active;
              this.stopAllSubsExerptCurrent(ID);
              this.togglePlayerStatus($thisObj.active);
            },
          },
          {
            active: false,
            icons: ["fa-clone"],
            tooltip: this.$t("copy_text"),
            network: "copy_text",
            render: true,
            cb: ({ ARABIC_TEXT }) => {
              this.copyToClipboard(ARABIC_TEXT);
            },
          },
          {
            active: false,
            icons: ["fa-share-alt"],
            tooltip: this.$t("share"),
            network: "share",
            render: true,
            cb: (sub) => {
              this.currentSubDikr = sub;
              this.shareDialog = true;
            },
          },
        ];
      });
      this.dikr = res;
      this.hasMulti = this.dikr.children.length > 1;
      if (this.hasMulti) {
        this.gotoSub();
      }
    });
    this.inFavList();
  },
  methods: {
    gotoSub() {
      const hash = this.$route.hash;
      if (!this.isEmpty(hash)) {
        const n = parseInt(hash.split("-")[1]);
        this.activeSubDikr = this.dikr.children.indexOf(
          this.dikr.children.find((el) => el.ID === n)
        );
      }
    },
    stopAllSubs() {
      this.dikr.children.forEach((d) => {
        d.actions[0].active = false;
      });
    },
    stopAllSubsExerptCurrent(id = "") {
      this.dikr.children.forEach((d) => {
        if (d.ID !== id) {
          d.actions[0].active = false;
        }
      });
    },
    endedHandler() {
      this.stopAllSubs();
    },
    togglePlayerStatus(value) {
      const player = this.$refs["sub-audio-player"];

      if (value) {
        player.addEventListener("canplay", () => {
          player.play();
        });
        if (player.paused) {
          player.play();
        }
      } else {
        player.pause();
      }
    },
    copyToClipboard(textToCopy) {
      navigator.clipboard.writeText(textToCopy);
      this.textCopiedSnackbar = true;
    },
    setDikrURL(id) {
      return (
        `${window.location.protocol}//${window.location.host}/shared?p=${this.dikr.ID}&c=` +
        id
      );
    },
    inFavList() {
      this.isFav = this.$store.getters.inFavList(this.slug);
    },
    toggleFav() {
      this.$store.dispatch("toggleFav", this.slug).then((f) => {
        this.isFav = f;
      });
    },
    nextSubDikr() {
      this.activeSubDikr++;
    },
    prevSubDikr() {
      if (this.activeSubDikr === 0) {
        this.activeSubDikr = this.dikr.children.length;
      }
      this.activeSubDikr--;
    },
  },
  metaInfo() {
    const title = this.slug;

    return { title };
  },
};
</script>
